import axios from "axios";
import { showNotification } from "./Notification";
import { TOKEN } from "constants/enums";
import callApi from "./apiCaller";

const CORE_API =
  process.env.REACT_APP_CORE_API || "https://prod-api.indxx.com";

/**
 * Helper function to upload a file to a specified API endpoint.
 * @param {string} url - The API endpoint URL.
 * @param {File} file - The file to be uploaded.
 * @returns {Promise<any>} - API response or error notification.
 */
const uploadFile = async (url: string, file: File): Promise<any> => {
  try {
    // Check for spaces in file name and reject if any
    // if (file.name.includes(" ")) {
    //   showNotification("File name must not contain spaces.", "error");
    //   throw new Error("File name contains spaces");
    // }

    // Check if file name is all lowercase 
    // if (file.name !== file.name.toLowerCase()) {
    //   showNotification("File name must be in all lowercase letters.", "error");
    //   throw new Error("File name is not all lowercase");
    // }

    // ✅ If file is an image, check its size
    if (file.type.startsWith("image/")) {
      const maxSize = 250 * 1024; // 250 KB in bytes
      if (file.size > maxSize) {
        showNotification("Image size must not exceed 250 KB.", "error");
        throw new Error("Image file size should be less then 250 KB.");
      }
    }


    const authUser = localStorage.getItem(TOKEN)?.replace(/^"|"$/g, ""); // Remove surrounding quotes
    if (!authUser) throw new Error("No Token Found!");

    const headers = {
      Authorization: `Bearer ${authUser}`,
      "Content-Type": "multipart/form-data",
    };

    const bodyFormData = new FormData();
    bodyFormData.append("file", file);

    const res = await axios.post(url, bodyFormData, { headers });

    if (res?.data?.status === "Success") {
      return res.data;
    } else {
      throw new Error("Upload failed");
    }
  } catch (error) {
    showNotification(
      error?.response?.data?.data?.message || "Error Occurred",
      "error"
    );
  }
};

// Exported uploader functions
export const imageUploader = (file: File, id: string) =>
  uploadFile(`${CORE_API}/api/v1/media/customer/${id}/upload`, file);

export const iconUploader = (file: File, id: string) =>
  uploadFile(`${CORE_API}/api/v1/icon/customer/${id}/upload`, file);

export const indexvalueUploader = (file: File, id: string) =>
  uploadFile(
    `${CORE_API}/api/v1/indexvalue/file-upload-v2?index_id=${id}&model_type=indexvalue`,
    file
  );

export const indexyieldUploader = (file: File) =>
  uploadFile(
    `${CORE_API}/api/v1/indexyield/file-upload?model_type=indexyield`,
    file
  );
export const indexmethadologyUploader = (file: File, id: string) =>
  uploadFile(
    `${CORE_API}/api/v1/index/upload-file?index_id=${id}&model_type=indexmethadology`,
    file
  );

export const indexconstituentUploader = (file: File, id: string) =>
  uploadFile(
    `${CORE_API}/api/v1/indexconstituents/file-upload?index_id=${id}&model_type=indexconstituents`,
    file
  );

export const indexDownload = async (url: string, id: string) => {
  try {
    const res = await callApi(`v1/indexupload/${id}/process-file`, "post", {
      modelType: url,
    });

    if (res?.status === "Success") {
      return res;
    }
  } catch (e) {
    showNotification(e.response.data.data.message || "Error occured", "error");
  }
};
